window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.cookies = require('js-cookie');

// CSRF
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// Setup Numbro

if (document.head.querySelector("[itemprop~=region][content]").content === 'US') {
	numbro.setLanguage(document.documentElement.lang);
	numbro.setDefaults('$0,0.00');
	numbro.defaultCurrencyFormat('$0,0.00');
}
numbro.setDefaults('0.0,00 €');
numbro.defaultCurrencyFormat('0.0,00 €');
